import React from 'react';
import Icon from '../../../components/Icon';
import {AddInputField, CheckboxInputField} from "../../../components/FormField";
import {LoadingBar} from "../../../components/Loader";
import Modal from "../../../components/Modal";
import Alert from "../../../components/Alert";

class RequestQuestionsBlockSuggestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: "",
            error: false,
            showAll: false,
            toggleAlert: false,
            questionId: ""
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    handleDelete(){
        this.props.handleDeleteQuestion(this.state.questionId);
        this.setState({toggleAlert: false});
    }

    onSubmit() {
        if(this.state.content.length >= 1){
            this.props.handleAddQuestion(this.props.group, this.state.content);
            this.setState({error: false, content: ""});
        } else {
            this.setState({error: true});
        }
    }

    render() {
        let listCheckboxCheck = this.props.listCheckboxCheck[this.props.group];
        let listFull = this.props.list.length >= 1 ? this.props.list.filter(item => item.group === this.props.group) : [];
        let list = this.state.showAll ? listFull : listFull.slice(0, 5);
        let listOfId = listCheckboxCheck.map(checkboxId => checkboxId._id);
        return (
            <div className="block">
                <div className={"category-title"}>{this.props.title}</div>
                {list.filter(item => item.group === this.props.group).map((item) => (
                    <div className={"row"} key={item._id}>
                        {!item.default && (<span onClick={()=>this.setState({questionId: item._id, toggleAlert: true})} className={"delete-question"}><Icon type="close" /></span>)}
                        <CheckboxInputField id={item._id}
                                            checked={!!listOfId.includes(item._id)}
                                            onChange={() => this.props.handleCheck(item, this.props.group)}
                                            htmlFor={item._id}
                                            label={item.content} />
                    </div>
                ))}
                <Modal toggle={this.state.toggleAlert} handleClose={()=>this.setState({toggleAlert: false})}>
                    <Alert handleClose={()=>this.setState({toggleAlert: false})}
                           text={"Voulez-vous vraiment supprimer cette question ?"}
                           handleDelete={()=>this.handleDelete()}  />
                </Modal>
                {this.props.questionsLoading && (
                    <LoadingBar />
                )}
                {!this.state.showAll && listFull.length > 5 && (
                    <span className="see-more mt-8" onClick={() => this.setState({showAll: true})}>Voir d'autres suggestions de questions <Icon
                        type="chevron-right"/></span>)}
                <div className="column add-question mt-8">
                    <span className={"add-question-label"}>Ajouter votre question : </span>
                    <AddInputField error={this.state.error}
                                   value={this.state.content}
                                   onChange={(event) => this.setState({'content': event.target.value})}
                                   callback={this.onSubmit}/>
                </div>

            </div>
        )
    }
}

export default RequestQuestionsBlockSuggestions;
